import { motion } from "framer-motion";

export default function TransitionBlock() {
	return (
		<div className="relative">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 100 100"
				preserveAspectRatio="none"
				className="w-full h-16 text-gray-50"
			>
				<polygon fill="currentColor" points="0,100 100,0 100,100" />
			</svg>
		</div>
	);
}
